module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/banners/new-baby-sitting-rc-6bebfd2d8284d35686b1ad03500ba5aa.svg";